import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useDeleteProduct = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/products/${id}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.root });

      return queryClient.invalidateQueries({ queryKey: QueryKeys.products.index });
    },
  });
};
